import { Checkbox, FormControlLabel } from '@mui/material';
import { BaseSyntheticEvent, useContext, useEffect, useMemo, useState } from 'react';

import { Spinner } from '@/components/common/Spinner';
import { LocaleContext } from '@/Contexts/LocaleContext';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

import RowWrap from './IntakeRowWrap';
import { stringHasValue } from '@/utils/stringUtil';

function NewPartnerCheckbox() {
  const { selectedProgramInfo, isNewPartner, updateIsNewPartner } =
    useContext(PartnerIntakeContext);
  const { translatedText } = useContext(LocaleContext);

  const [value, setValue] = useState(false);

  const partnerTerm = useMemo(() => {
    return selectedProgramInfo.partnerTerm;
  }, [selectedProgramInfo]);

  const programName = useMemo(() => {
    return selectedProgramInfo.programName;
  }, [selectedProgramInfo]);

  useEffect(() => {
    if (isNewPartner !== value) setValue(isNewPartner);
  }, [isNewPartner, value]);

  return !stringHasValue(programName) || !stringHasValue(partnerTerm) ? (
    <Spinner type={'circular'} size={18} />
  ) : (
    <RowWrap>
      <FormControlLabel
        sx={{ marginTop: '0px' }}
        control={
          <Checkbox
            checked={value}
            onClick={(event: BaseSyntheticEvent) => {
              const isChecked = (event.target as HTMLInputElement).checked;

              updateIsNewPartner(isChecked);
            }}
          />
        }
        label={translatedText.signup.labelAppliedToADF(partnerTerm, programName)}
      />
    </RowWrap>
  );
}

export default NewPartnerCheckbox;
